import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SEO from '@/components/feature/SEO';
import HeroSection from './components/HeroSection';
import FeaturedGrid from './components/FeaturedGrid';
import CategoryShowcase from './components/CategoryShowcase';
import RankingSection from './components/RankingSection';
import CTASection from './components/CTASection';
import LatestSection from './components/LatestSection';
import TestimonialSection from './components/TestimonialSection';

const homeWebSiteLD = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  'name': '韩漫之家',
  'alternateName': 'HanMan Home',
  'url': 'http://dnchemical.com/',
  'description': '免费韩漫下拉式在线阅读平台，提供高清韩国漫画大全资源',
  'potentialAction': {
    '@type': 'SearchAction',
    'target': 'http://dnchemical.com/search?q={search_term_string}',
    'query-input': 'required name=search_term_string',
  },
  'inLanguage': 'zh-CN',
};

const homeOrgLD = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  'name': '韩漫之家',
  'url': 'http://dnchemical.com/',
  'description': '国内领先的免费韩漫在线阅读平台',
  'foundingDate': '2018',
  'contactPoint': {
    '@type': 'ContactPoint',
    'email': 'hello@dnchemical.com',
    'contactType': 'Customer Service',
    'availableLanguage': ['Chinese'],
  },
};

const homeWebPageLD = {
  '@context': 'https://schema.org',
  '@type': 'WebPage',
  'name': '免费韩漫-韩国漫画下拉式在线阅读-高清漫画大全-韩漫之家',
  'description': '韩漫之家为您呈现免费韩漫和韩国漫画下拉式在线阅读，拥有高清漫画大全资源，让阅读过程更生动逼真，满足您对多样化故事的需求。',
  'url': 'http://dnchemical.com/',
  'isPartOf': { '@type': 'WebSite', 'name': '韩漫之家', 'url': 'http://dnchemical.com/' },
  'inLanguage': 'zh-CN',
};

export default function Home() {
  return (
    <>
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(homeWebSiteLD) }} />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(homeOrgLD) }} />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(homeWebPageLD) }} />
      <SEO
        title="免费韩漫-韩国漫画下拉式在线阅读-高清漫画大全-韩漫之家"
        description="韩漫之家为您呈现免费韩漫和韩国漫画下拉式在线阅读，拥有高清漫画大全资源，让阅读过程更生动逼真，满足您对多样化故事的需求。"
        keywords="免费韩漫,韩国漫画下拉式在线阅读,高清漫画大全,韩漫之家"
        canonicalUrl="http://dnchemical.com/"
      />
      <Navbar />
      <main>
        <HeroSection />
        <FeaturedGrid />
        <CategoryShowcase />
        <RankingSection />
        <CTASection />
        <LatestSection />
        <TestimonialSection />
      </main>
      <Footer />
    </>
  );
}